import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "@/lib/motion";

const words = ["Data", "Leads", "AI", "Websites", "Automations"];

export const TypewriterText = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % words.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <span className="inline-block relative min-w-[180px] sm:min-w-[250px]">
      <AnimatePresence mode="wait">
        <motion.span
          key={words[currentIndex]}
          initial={{ opacity: 0, y: 40, rotateX: -90 }}
          animate={{ opacity: 1, y: 0, rotateX: 0 }}
          exit={{ opacity: 0, y: -40, rotateX: 90 }}
          transition={{ 
            duration: 0.5, 
            ease: [0.16, 1, 0.3, 1]
          }}
          className="inline-block text-gradient"
        >
          {words[currentIndex]}
        </motion.span>
      </AnimatePresence>
      <motion.span
        className="absolute -right-2 top-0 h-full w-[3px] bg-primary"
        animate={{ opacity: [1, 1, 0, 0] }}
        transition={{ duration: 1, repeat: Infinity, times: [0, 0.5, 0.5, 1] }}
      />
    </span>
  );
};
